import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useGetMenuMaster } from 'api/menu';
import { getBuildMeta } from 'utils/buildMeta';

export default function DrawerBuildInfo() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDesktopDrawerExpanded ?? true;
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const showExpanded = downLG || drawerOpen;
  const build = getBuildMeta();

  const content = showExpanded ? (
    <Box sx={{ px: 2, py: 1.25, minWidth: 0 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', lineHeight: 1.3, fontFamily: 'ui-monospace, monospace' }}
      >
        Build {build.number}
      </Typography>
      <Typography variant="caption" color="text.disabled" sx={{ display: 'block', lineHeight: 1.3, fontSize: '0.65rem' }}>
        {build.timeLabel}
      </Typography>
    </Box>
  ) : (
    <Tooltip title={`Build ${build.number} · ${build.timeLabel}`} placement="right" arrow>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          display: 'block',
          px: 0.5,
          py: 1.25,
          textAlign: 'center',
          fontFamily: 'ui-monospace, monospace',
          fontSize: '0.6rem',
          lineHeight: 1.2,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
      >
        {build.number.split('.').pop() || build.number}
      </Typography>
    </Tooltip>
  );

  return (
    <Box sx={{ flexShrink: 0, mt: 'auto' }}>
      <Divider sx={{ mx: showExpanded ? 2 : 1.25 }} />
      {content}
    </Box>
  );
}
